var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _circle2, _path15, _circle3, _path16, _circle4, _path17, _circle5, _path18, _path19, _path20, _path21, _rect, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnimelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.93,
    height: 81.93,
    viewBox: "0 0 81.93 81.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.26,80.47c-14.91,2.92-29.37-6.8-32.3-21.71-2.92-14.91,6.8-29.37,21.71-32.3,14.91-2.92,29.37,6.8,32.3,21.71,2.92,14.91-6.8,29.37-21.71,32.3Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.18,29.95c2.97,3.48,5.12,7.73,6.06,12.54,2.92,14.91-6.8,29.37-21.71,32.3-6.99,1.37-13.86-.06-19.51-3.48,6.24,7.32,16.13,11.16,26.24,9.17,14.91-2.92,24.63-17.38,21.71-32.3-1.55-7.92-6.38-14.35-12.78-18.23Z",
    fill: "#a7c0ce",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9,81.93c-5.6,0-11.07-1.66-15.81-4.85-6.31-4.24-10.59-10.68-12.05-18.14-1.46-7.46.07-15.04,4.31-21.35,4.24-6.31,10.68-10.59,18.14-12.05,15.39-3.02,30.38,7.05,33.4,22.45,3.02,15.4-7.05,30.38-22.45,33.4-1.84.36-3.7.54-5.53.54ZM40.97,26.89c-1.69,0-3.4.16-5.12.5-6.97,1.37-12.98,5.36-16.95,11.25-3.96,5.89-5.39,12.97-4.02,19.94,1.37,6.97,5.36,12.99,11.25,16.95,5.89,3.96,12.97,5.39,19.94,4.02h0c14.38-2.82,23.79-16.81,20.97-31.19-2.48-12.66-13.63-21.47-26.07-21.47Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.29,65.21l-.66-2.63h-11.34l-.66,2.63c-.4,1.59-1.51,2.88-2.96,3.52l9.3,4.95,9.29-4.95c-1.45-.65-2.56-1.93-2.96-3.52Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.97,74.63c-.15,0-.3-.04-.44-.11l-9.3-4.95c-.32-.17-.51-.5-.5-.86.01-.36.23-.68.56-.82,1.22-.54,2.11-1.6,2.43-2.89l.66-2.63c.11-.42.48-.71.91-.71h11.34c.43,0,.8.29.91.71l.66,2.63c.33,1.3,1.21,2.35,2.43,2.89.33.15.54.47.56.82.01.36-.18.69-.5.86l-9.29,4.95c-.14.07-.29.11-.44.11ZM33.53,68.67l7.43,3.96,7.42-3.96c-.98-.82-1.69-1.94-2.01-3.22l-.48-1.92h-9.87l-.48,1.92c-.32,1.28-1.03,2.4-2.01,3.22Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.19,50.79c0,7.55-5.02,13.67-11.22,13.67s-11.22-6.12-11.22-13.67,5.02-11.53,11.22-11.53,11.22,3.98,11.22,11.53Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96,65.4c-6.71,0-12.16-6.55-12.16-14.61,0-7.46,4.89-12.47,12.16-12.47s12.16,5.01,12.16,12.47c0,8.06-5.46,14.61-12.16,14.61ZM40.96,40.19c-6.25,0-10.29,4.16-10.29,10.6,0,7.02,4.61,12.73,10.29,12.73s10.29-5.71,10.29-12.73c0-6.44-4.04-10.6-10.29-10.6Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.95,47.77c-4.68-1.72-8.55-1.27-10.74-.71-.3,1.13-.47,2.37-.47,3.73,0,7.55,5.02,13.67,11.22,13.67s11.22-6.12,11.22-13.67c0-.96-.08-1.86-.24-2.7-2.61.68-6.77,1.24-11-.32Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.95,48.09c-1.34.35-3.09.66-5.04.67-.26,7.27-5.17,13.07-11.2,13.07-.51,0-1-.05-1.49-.13,1.88,1.73,4.21,2.76,6.74,2.76,6.2,0,11.22-6.12,11.22-13.67,0-.96-.08-1.86-.24-2.7Z",
    fill: "#a7c0ce",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96,65.4c-6.71,0-12.16-6.55-12.16-14.61,0-1.4.17-2.74.51-3.98.09-.33.35-.58.68-.67,2.51-.63,6.51-1.01,11.29.74,3.95,1.45,7.86.96,10.44.29.25-.07.52-.02.74.12.22.14.37.37.42.62.17.91.25,1.88.25,2.87,0,8.06-5.46,14.61-12.16,14.61ZM30.99,47.84c-.21.93-.31,1.92-.31,2.95,0,7.02,4.61,12.73,10.29,12.73s10.29-5.71,10.29-12.73c0-.53-.03-1.05-.08-1.55-2.8.59-6.63.85-10.54-.59h0c-4-1.47-7.37-1.29-9.64-.81Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96,80.99c8.16,0,15.49-3.56,20.53-9.2-.98-.76-2.14-1.31-3.43-1.54l-6.56-1.13c-.44-.08-.86-.2-1.25-.38l-9.29,4.95-9.3-4.95c-.39.18-.81.3-1.25.38l-6.56,1.13c-1.29.22-2.45.78-3.43,1.54,5.04,5.65,12.37,9.2,20.53,9.2Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.19,69.85l-2.33.4c-1.29.22-2.45.78-3.43,1.54,5.04,5.65,12.37,9.2,20.53,9.2s15.49-3.56,20.53-9.2c-.2-.15-.4-.29-.61-.42-4.58,3.42-10.26,5.44-16.42,5.44-7.02,0-13.41-2.63-18.27-6.96Z",
    fill: "#a7c0ce",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96,81.93c-8.09,0-15.83-3.47-21.23-9.52-.17-.19-.26-.45-.23-.71.02-.26.15-.5.36-.66,1.17-.9,2.46-1.48,3.84-1.72l6.56-1.13c.36-.06.7-.17,1.03-.31.26-.12.57-.11.82.03l8.86,4.72,8.85-4.72c.25-.14.56-.15.82-.03.32.15.67.25,1.03.31l6.56,1.13c1.38.24,2.68.82,3.84,1.72.21.16.34.4.36.66.02.26-.06.52-.23.71-5.4,6.05-13.14,9.52-21.23,9.52ZM21.87,71.95c5,5.16,11.9,8.1,19.1,8.1s14.1-2.94,19.1-8.1c-.68-.39-1.4-.65-2.15-.78l-6.56-1.13c-.35-.06-.7-.15-1.03-.27l-8.9,4.75c-.28.15-.61.15-.88,0l-8.91-4.75c-.33.12-.68.21-1.03.27l-6.56,1.13c-.75.13-1.47.39-2.16.78Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.23,
    cy: 78.49,
    r: 2.5,
    fill: "#fff",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.23,81.93c-1.9,0-3.44-1.54-3.44-3.44s1.54-3.44,3.44-3.44,3.44,1.54,3.44,3.44-1.54,3.44-3.44,3.44ZM67.23,76.93c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56,1.56-.7,1.56-1.56-.7-1.56-1.56-1.56Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.49,
    cy: 63.48,
    r: 2.5,
    fill: "#fff",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.49,66.92c-1.9,0-3.44-1.54-3.44-3.44s1.54-3.44,3.44-3.44,3.44,1.54,3.44,3.44-1.54,3.44-3.44,3.44ZM78.49,61.92c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56,1.56-.7,1.56-1.56-.7-1.56-1.56-1.56Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.73,
    cy: 40.97,
    r: 2.5,
    fill: "#fff",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.73,44.41c-1.9,0-3.44-1.54-3.44-3.44s1.54-3.44,3.44-3.44,3.44,1.54,3.44,3.44-1.54,3.44-3.44,3.44ZM74.73,39.4c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56,1.56-.7,1.56-1.56-.7-1.56-1.56-1.56Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.44,
    cy: 70.99,
    r: 2.5,
    fill: "#fff",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44,74.43c-1.9,0-3.44-1.54-3.44-3.44s1.54-3.44,3.44-3.44,3.44,1.54,3.44,3.44-1.54,3.44-3.44,3.44ZM8.44,69.42c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56,1.56-.7,1.56-1.56-.7-1.56-1.56-1.56Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.44,
    cy: 50.97,
    r: 2.5,
    fill: "#fff",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44,54.41c-1.9,0-3.44-1.54-3.44-3.44s1.54-3.44,3.44-3.44,3.44,1.54,3.44,3.44-1.54,3.44-3.44,3.44ZM3.44,49.41c-.86,0-1.56.7-1.56,1.56s.7,1.56,1.56,1.56,1.56-.7,1.56-1.56-.7-1.56-1.56-1.56Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19.94h77.55c.69,0,1.25.56,1.25,1.25v28.77c0,.69-.56,1.25-1.25,1.25H23.45l2.5,12.51-15.01-12.51H2.19c-.69,0-1.25-.56-1.25-1.25V2.19c0-.69.56-1.25,1.25-1.25Z",
    fill: "#a7c0ce",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94.94h72.8v24.02c0,.55-.45,1-1,1H.94V1.94c0-.55.45-1,1-1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.95,45.65c-.21,0-.43-.07-.6-.22l-14.75-12.29H2.19c-1.21,0-2.19-.98-2.19-2.19V2.19C0,.98.98,0,2.19,0h77.55c1.21,0,2.19.98,2.19,2.19v28.77c0,1.21-.98,2.19-2.19,2.19H24.6l2.28,11.39c.08.39-.1.79-.44.99-.15.09-.31.13-.48.13ZM2.19,1.88c-.17,0-.31.14-.31.31v28.77c0,.17.14.31.31.31h8.75c.22,0,.43.08.6.22l12.97,10.81-1.98-9.9c-.05-.28.02-.56.19-.78.18-.22.44-.34.73-.34h56.28c.17,0,.31-.14.31-.31V2.19c0-.17-.14-.31-.31-.31H2.19Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.82,
    y: 7.82,
    width: 17.51,
    height: 17.51,
    rx: 1,
    ry: 1,
    fill: "#a7c0ce",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82,12.82h11.51v11.51c0,.55-.45,1-1,1h-11.51v-11.51c0-.55.45-1,1-1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08,26.27h-15.01c-1.21,0-2.19-.98-2.19-2.19v-15.01c0-1.21.98-2.19,2.19-2.19h15.01c1.21,0,2.19.98,2.19,2.19v15.01c0,1.21-.98,2.19-2.19,2.19ZM9.07,8.76c-.17,0-.31.14-.31.31v15.01c0,.17.14.31.31.31h15.01c.17,0,.31-.14.31-.31v-15.01c0-.17-.14-.31-.31-.31h-15.01Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.73,11.26h-6.88c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h6.88c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.85,11.26h-11.88c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h11.88c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.97,11.26h-14.39c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h14.39c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.73,17.51h-13.13c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h13.13c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6,17.51h-10.63c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h10.63c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.96,17.51h-9.38c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h9.38c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.85,23.76h-9.38c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h9.38c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.47,23.76h-16.89c-.52,0-.94-.42-.94-.94s.42-.94.94-.94h16.89c.52,0,.94.42.94.94s-.42.94-.94.94Z",
    fill: "#153d57",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnimelIcon);
export default __webpack_public_path__ + "static/media/unimel_icon.14e24f4306111e9963dbc2191a2bec7e.svg";
export { ForwardRef as ReactComponent };